import { browserSessionPersistence, getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
const auth = getAuth();
const db = getFirestore();

async function logIn(username, password) {
  return auth.setPersistence(browserSessionPersistence).then(() => {
    return signInWithEmailAndPassword(auth, username, password);
  });
}
async function completeLogin() {
  return auth.currentUser;
}
const authModule = {
  namespaced: true,
  state: () => ({
    user: undefined,
    token: undefined,
    loginError: undefined,
    forgotError: undefined,
    loggedIn: false,
    loading_user: false,
    url: '',
    regId: ''
  }),
  getters: {
    isLoading: (state) => {
      return state.loading_user;
    },
    getUser: (state) => {
      return state.user;
    },
    getToken: (state) => {
      return state.token;
    },
    getLoginError: (state) => {
      return state.loginError;
    },
    getForgotError: (state) => {
      return state.forgotError;
    },
    isDriver: (state) => {
      if (state.token) {
        return state.token.claims.driver;
      }
      return false;
    },
    isAdmin: (state) => {
      if (state.token)
        return state.token.claims.admin;
      return false;
    },
    isClient: (state) => {
      if (state.token)
        return state.token.claims.client;
      return false;
    },
    isLoggedIn: (state) => {
      return state.loggedIn;
    },
    getRedirectUrl: (state) => {
      return state.url;
    },
    getRegId: (state) => {
      return state.regId;
    }
  },
  mutations: {
    setLoading(state, loading){
      state.loading_user = loading;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setLoginSuccess(state) {
      state.loggedIn = true;
    },
    setLoginError(state, error) {
      state.loggedIn = false;
      state.loginError = error;
    },
    setForgotError(state, error) {
      state.forgotError = error;
    },
    logout(state) {
      state.user = undefined;
      state.token = undefined;
      state.loggedIn = false;
    },
    redirectUrl(state, url){
      state.url = url;
    },
    setRegId(state, id){
      state.regId = id;
    }
  },
  actions: {
    login(context, { username, password }) {
      logIn(username, password)
      .then(() => {
        console.log('logged in');
      })
        .catch((error) => {
          context.commit('setLoginError', error);
          console.log(error)
        });
    },
    async forgot(context, email){
      await sendPasswordResetEmail(auth, email)
      .then(() => {
        alert(`Password reset for ${email} has been confirmed.\nPlease check your email spam folder if you don't see the email in your inbox folder`);
      })
      .catch((err) => {
        alert(err);
        context.commit('setForgotError', err);
      });

    },
    completeLogin(context) {
      if(!context.getters.isLoggedIn){
        context.commit("setLoading", true);
        completeLogin().then(async (user) => {
          if (user) {
            const docRef = doc(db, 'users', user.uid);
            const docSnap = await getDoc(docRef);
            
            const token = user.getIdTokenResult();
  
            await Promise.all([docSnap, token])
              .then(async ([userMeta, tokenData]) => {
                let userData = userMeta.data();
                // if card user doesn't have expiry on his profile, add it
                if (userData?.card && !userData?.card?.expiry) {
                  console.log('no user card expiry')
                  var myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  var raw = JSON.stringify({
                    "registrationId": userData.card.registrationId
                  });
                  var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'follow'
                  };
                  await fetch("https://us-central1-wrapp-waste.cloudfunctions.net/viewCard", requestOptions) // for production use: https://us-central1-wrapp-waste.cloudfunctions.net/viewCard
                  .then(async (response) => {
                    let data = await response.json();
                    if(data.card){
                      await setDoc(doc(db, 'users', user.uid), {
                        ...userData,
                        card: {
                          registrationId: userData.card.registrationId,
                          expiry: data.card.expiryMonth + '/' + data.card.expiryYear
                        }
                      }, {merge: true})
                      .then(() => {
                        userData = docSnap.data();
                      })
                    }
                  })
                  .catch(error => {
                    console.log('error', error);
                  });
                }

                const loggedInUser = { ...userData, id: userMeta.id };
                context.commit('setToken', tokenData);
                context.commit('setUser', loggedInUser);
                context.commit('setLoginSuccess');
                context.commit("setLoading", false);
              });
          } else {
            context.commit('logout');
          }
        })   
      }
    },
    async registerUser(context, user){
      const fname = user.firstName.replace(/\s+/g, ' ');
      const lname = user.lastName.replace(/\s+/g, ' ');
      const companyName = user.companyName.replace(/\s+/g, ' ');

      await setDoc(doc(db, 'users', user.id), {
        mobile: user.mobile,
        firstName: fname,
        lastName: lname,
        companyName: companyName,
        vatNo: user.vatNo,
        emailAddress: user.emailAddress,
        scope: user.scope
      }, { merge: true })
      .then(async() =>{
        await getDoc(doc(db, 'users', user.id))
        .then((snapshot) =>{
          context.commit('setUser', snapshot.data());
        })
      })
      .catch((err) =>{
        alert(err);
        console.log(err);
      });
    },
    async registerUserCard(context, user){
      let expM = user.month.substring(0,2);
      let expY = user.month.substring(3);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "fname": user.fname,
        "lname": user.lname,
        "emailAddress": user.emailAddress,
        "password": btoa(user.password),
        "card": user.cardno,
        "expMonth": expM,
        "expYear": expY,
        "cvv": user.cvv
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      //register peach customer
      await fetch("https://us-central1-wrapp-waste.cloudfunctions.net/peachCustomer", requestOptions)
      .then(async (response) => {
        let data = await response.text();
        let resData = JSON.parse(data);

        context.commit('redirectUrl', resData.redirect ? resData.redirect.url : '');
        context.commit('setRegId', resData.registrationId ? resData.registrationId  : '');

        if(resData.result.code == '000.200.000'){
          await setDoc(doc(db, 'users', user.id), {
            card: {
              registrationId: resData.registrationId,
              expiry: user.month
            }
          }, {merge: true}) 
          .catch((err) => console.log(err));
        }
        else{
          alert(resData.result.description);
        }
      })
      .catch(error => {
        console.log('error', error);
      });
    },
    async completeRegistration(context, user){
      await setDoc(doc(db, 'users', user.id), {
        registered: true
      }, { merge: true })
      .then(() => console.log('registered'))
      .catch((err) =>{
        console.log(err);
      })
    },
    async updateUserCard(context, user){
      await setDoc(doc(db, 'users', user.id), {
        card: {
          registrationId: user.registrationId,
          ...(user.expiry ? { expiry: user.expiry } : {})
        }
      }, {merge: true})
      .then(async () => {
        await getDoc(doc(db, 'users', user.id))
        .then((snapshot) =>{
          context.commit('setUser', snapshot.data());
        })
      }).catch((err) => alert(err));
    }
  }
}

export default authModule;